import React from "react";
import styled from "styled-components";

const ProgressBarContainer = styled.div`
    width: 70%;
    height: 0.8rem;
    margin-top: 0.5rem;
    background-color: transparent;
    border-radius: 8px;
`;

const ProgressBarFiller = styled.div`
    width: ${props => props.width + 10}%;
    height: 0.8rem;
    background-color: ${props => props.color || "#007bff"};
    border-radius: 8px;
`;

const PrintableProgressBar = ({ value, moodType }) => {
    const moodColors = {
        Happy: "#654CB8",
        Content: "#4C86B8",
        Neutral: "#4CB8B8",
        Sad: "#4CB858",
        Unhappy: "#C3CE45",
        Tired: "#FF981F",
        Stressed: "#D94B4B",
        Sick: "#B7D3A8",
    };

    // Get the color based on the moodType, or use the default color
    const color = moodColors[moodType] || "#007bff";


    return (
        <ProgressBarContainer>
            <ProgressBarFiller width={value} color={color} />
        </ProgressBarContainer>
    );
};

export default PrintableProgressBar;